import { useState } from 'react'
import { Alert, Button, Flex, Typography } from 'antd'
import { useTranslation } from 'react-i18next'
import { Navigate, useLocation, useNavigate } from 'react-router-dom'
import { translateError } from '@/shared/api/errors'
import type { TenantCandidate } from '@/shared/auth/AuthContext'
import { useAuth } from '@/shared/auth/useAuth'
import { AuthShell } from './AuthShell'

export interface TenantChoiceState {
  choiceToken: string
  candidates: TenantCandidate[]
  from: string
}

/**
 * Kirish oqimining OXIRGI qadami — bir nechta tashkilotga a'zo sherik
 * uchun.
 *
 * ⚠️ SHERIK ODATDA BITTA TASHKILOTDA bo'ladi (ADR-029 §2: to'plami
 * kodda qotirilgan), ya'ni bu ekran deyarli hech qachon ochilmaydi.
 * Baribir kerak: `LoginFlowService` sherik va xodim uchun BITTA va u
 * ko'p a'zolikni ko'rsa `CHOOSE_TENANT` qaytaradi. Ekran bo'lmasa
 * o'sha odam kira olmasdi — hech qanday xato ko'rsatmasdan.
 *
 * ⚠️ Holat NAVIGATSIYA orqali keladi, URL'da emas — sabab
 * `TotpPage` izohida (`choiceToken` — qisqa umrli sir).
 */
export function TenantChoicePage() {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const location = useLocation()
  const { completeTenantChoice } = useAuth()

  const [pending, setPending] = useState<string | null>(null)
  const [error, setError] = useState<string | null>(null)

  const state = location.state as TenantChoiceState | null
  if (!state?.choiceToken || !Array.isArray(state.candidates)) {
    return <Navigate to="/login" replace />
  }

  const choose = (tenantId: string) => {
    setPending(tenantId)
    setError(null)
    void completeTenantChoice(state.choiceToken, tenantId)
      .then(() => navigate(state.from, { replace: true }))
      .catch((err: unknown) => {
        setError(translateError(err, t))
        setPending(null)
      })
  }

  return (
    <AuthShell title={t('auth.tenant.title')} subtitle={t('auth.tenant.subtitle')} width={460}>
      {error ? <Alert type="error" showIcon message={error} style={{ marginBottom: 16 }} /> : null}

      <Flex vertical gap={8}>
        {state.candidates.map((candidate) => (
          <Button
            key={candidate.tenantId}
            block
            size="large"
            loading={pending === candidate.tenantId}
            disabled={pending !== null && pending !== candidate.tenantId}
            onClick={() => choose(candidate.tenantId)}
            style={{ height: 'auto', paddingBlock: 10, textAlign: 'start' }}
          >
            <Flex vertical align="flex-start" gap={0}>
              <Typography.Text strong>{candidate.name}</Typography.Text>
              <Typography.Text type="secondary" style={{ fontSize: 12 }}>
                {candidate.code}
              </Typography.Text>
            </Flex>
          </Button>
        ))}
      </Flex>
    </AuthShell>
  )
}
